import { logErrorWithContext } from 'shared/utils/sentry/sentry';
import {
  ErrorSeverity,
  FeatureArea,
  ResponsibleTeam,
} from 'shared/utils/sentry/sentry.constants';
/**
 * Handles downloading and sharing the Direct Deposit PDF form based on the platform.
 * @param pdfURL The source URL of the PDF form.
 */
export const downloadDirectDepositForm = async (
  pdfURL: string,
): Promise<void> => {
  try {
    const link = document.createElement('a');
    link.href = pdfURL;
    link.target = '_blank';
    link.download = 'DirectDepositForm.pdf';
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    logErrorWithContext('Direct deposit form download error(web): ' + error, {
      featureArea: FeatureArea.DIRECT_DEPOSIT,
      responsibleTeam: ResponsibleTeam.CUSTOMER_ACQUISITION,
      severity: ErrorSeverity.MEDIUM,
    });
  }
};
